import { createClassName } from 'utils/createClassName';

import './selectStyles.scss';

export const createSelectClassName = createClassName('select');
